
import '../App.css';
import { useParams, useNavigate} from 'react-router-dom';
import { Component } from 'react';
import EnvironmentService from "../service/environmentService";
import ShowService from '../service/showService';

function withParams(Component) {
  return props => <Component {...props} params={useParams()} Navigate={useNavigate()} />;
}


class ShowsOverview extends Component {
    // var movies = [];



  constructor(props){
    super(props);

    this.environmentService = new EnvironmentService();
    this.ShowService = new ShowService();

    console.log("HMMMMMM " +  props.uuid);
    this.state = {
        shows : []
    }
  }

  componentDidMount(){
    this.getShows();
  }

  async getShows(){
    let result = await this.ShowService.GetShows();
   this.setState({
    shows : result
   });
  }

  render(){
    const shows = this.state.shows;
    if(!shows) return null;


    return(
       <div>
          <div>
            <text class="page-title">Shows</text>
          </div>
          <div class="grid-container">
            {shows.map((show) =>(
              <div class="grid-item" key={show.uuid}>
                <a href={this.environmentService.getFrontEndEnvironmentHost() + '/shows/' + show.uuid} className='link-hidden'>
                  <div>
                    <text> 
                        {show.name}<br/>
                        {show.releaseDate}
                    </text>
                  </div>
                </a>
              </div>
            ))
          }
          </div>
       </div> 
      )

  }




}

export default withParams(ShowsOverview);
